import ThreeApp from "../utils/init";
import * as THREE from "three";
import { MarchingCubes } from "three/examples/jsm/objects/MarchingCubes.js";

function threeAnim() {
    const canvas = document.querySelector("#circle-anim");
    if (!canvas) return;

    const app = new ThreeApp({
        canvas,
        camera: {
            position: new THREE.Vector3(0, 0, 1.0),
        },
    });

    // === MarchingCubes（メタボール） ===
    // 解像度は毎フレームの CPU 負荷に直結する(64→48 で約半分。見た目の差はわずか)
    const resolution = 48;
    const material = new THREE.MeshStandardMaterial({
        color: 0x042a2b,
        metalness: 0.0,
        roughness: 0.35,
    });
    const effect = new MarchingCubes(resolution, material, true, true);
    effect.isolation = 56;
    effect.position.set(0, 0, 0);
    effect.scale.set(1, 1, 1);
    app.add(effect);

    // === パラメータ ===
    const PARAMS = {
        balls: 3, // 球の数
        radius: 0.35, // 球の軌道半径
        speed: 0.5, // 動く速さ
        strength: 1.4, // 球の“大きさ”
        subtract: 20.0, // 形のシャープさ
    };

    // === メタボールの更新 ===
    function updateField(t) {
        effect.reset();

        for (let i = 0; i < PARAMS.balls; i++) {
            const time = t * 0.5;
            const r = PARAMS.radius * Math.sin(t);
            const v = i % PARAMS.balls;
            const ang = r * Math.cos(time) + (v * ((Math.PI * 2) / PARAMS.balls) - Math.PI / 2) * Math.sin(time);

            let x = 0.5 + r * Math.cos(ang);
            let y = 0.5 + r * Math.sin(ang);
            let z = 0;

            effect.addBall(x, y, z, PARAMS.strength * 0.5 * (i + 1), PARAMS.subtract);
        }

        effect.update();
    }

    app.on("update", (t) => {
        updateField(t);
    });

    // 画面外ではループを止めて負荷を抑える
    const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
            app.start();
        } else {
            app.stop();
        }
    });
    observer.observe(canvas);
}

export { threeAnim };
